import type { IGameEngineFilterValue } from './types';

export const DEFAULT_SELECTOR_CONFIG = {
  label: 'dbi_top_game_engine',
  tipLabel: 'dbi_top_game_engine',
  tipText: 'dbi_top_game_engine_tip',
  logicLabel: 'dbi_game_engine_logic_label',
  logicTipText: 'dbi_game_engine_logic_tip',
  placeholder: 'dbi_top_game_engine_placeholder',
  searchPlaceholder: 'dbi_top_game_engine_search_placeholder',
};

export const getGameEngineValue = (value: unknown): IGameEngineFilterValue => {
  const relationalValue = value as IGameEngineFilterValue | undefined;

  return {
    logic: relationalValue?.logic || 'OR',
    value: relationalValue?.value || [],
  };
};
